// The icon set, backed by lucide-react.
//
// Re-exported under our own names so components never import lucide directly:
// the whole set can be swapped, resized or restyled from this one file, and
// call sites stay readable ("PinIcon", not "MapPin"). Every icon inherits
// currentColor and a 1.75 stroke so they sit consistently next to Inter.
import React from "react";
import {
  Users,
  Globe,
  Trophy,
  Calendar,
  MapPin,
  TrendingUp,
  RefreshCw,
  Building2,
  Sparkles,
  ArrowRight,
  ArrowLeft,
  ChevronRight,
  Search,
  X,
  Menu,
  ShieldCheck,
  User,
  BadgeCheck,
  Image as ImageGlyph,
  Upload,
  Trash2,
  AlertCircle,
} from "lucide-react";

// Wraps a lucide component so our call sites keep passing `className` only.
const make = (Component) => {
  const Wrapped = ({ className = "", strokeWidth = 1.75, ...props }) => (
    <Component
      className={`h-5 w-5 ${className}`}
      strokeWidth={strokeWidth}
      aria-hidden="true"
      {...props}
    />
  );
  Wrapped.displayName = `Icon(${Component.displayName || Component.name})`;
  return Wrapped;
};

export const UsersIcon = make(Users);
export const GlobeIcon = make(Globe);
export const TrophyIcon = make(Trophy);
export const CalendarIcon = make(Calendar);
export const PinIcon = make(MapPin);
export const TrendIcon = make(TrendingUp);
export const RefreshIcon = make(RefreshCw);
export const BuildingIcon = make(Building2);
export const SparkleIcon = make(Sparkles);
export const ArrowRightIcon = make(ArrowRight);
export const ArrowLeftIcon = make(ArrowLeft);
export const ChevronRightIcon = make(ChevronRight);
export const SearchGlyph = make(Search);
export const CloseIcon = make(X);
export const MenuIcon = make(Menu);
export const ShieldIcon = make(ShieldCheck);
export const UserIcon = make(User);
export const VerifiedIcon = make(BadgeCheck);
export const ImageIcon = make(ImageGlyph);
export const UploadIcon = make(Upload);
export const TrashIcon = make(Trash2);
export const AlertIcon = make(AlertCircle);
